export default {
  completeProfile: {
    intro: {
      title: "Let's set things up",
      subtitle: "A few quick permissions help us show more relevant odds, send timely updates, and improve your overall experience.",
    },
    tracking: {
      title: "Help keep Linemate free",
      subtitle: "We ask for your permission to track some activity on this device. By selecting “Allow Tracking” on the next screen, you'll help us:",
      buttonSubtext: "You can change this option later in the Settings app",
      cards: {
        support: {
          title: "Support Linemate",
          body: "This helps us continue improving the app and the features you use most.",
        },
        relevantContent: {
          title: "See more relevant content",
          body: "We use this data to show offers, trends, and ads that are more relevant to you.",
        },
      },
    },
  },
};